const STORAGE_KEY = "hideServeFirst";

export const isServeFirstBrandingHidden = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const isServeFirstBrandingResolved = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) !== null;
  } catch {
    return false;
  }
};

export const setServeFirstBrandingHidden = (hidden) => {
  const shouldHide = hidden === true || hidden === "true";

  try {
    sessionStorage.setItem(STORAGE_KEY, String(shouldHide));
  } catch {
    // Storage can be unavailable in privacy-restricted browsers.
  }

  return shouldHide;
};
